'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {
//   Link,
//   LinkIcon
// } from '../'
// import config from '../../config'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _lodash = require('lodash');

var _CompanyList = require('./CompanyList.css');

var _CompanyList2 = _interopRequireDefault(_CompanyList);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MaxPerPage = 10;

function mapFundHoldings(fHoldings) {
  var fHoldingsMap = {};
  fHoldings.forEach(function (fholding) {
    fHoldingsMap[fholding.db_holding_id] = fholding;
  });
  return fHoldingsMap;
}
// function filterHoldings(fHoldingsMap, holdings, filterFn){
//   return chain(holdings)
//   .filter(filterFn)
//   // .sortBy((o)=>{
//   //   return fHoldingsMap[o.id].market_value * -1
//   // })
//   // .take(10)
//   .value()
// }

var CompanyList = (_dec = (0, _reactCssModules2.default)(_CompanyList2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CompanyList, _Component);

  function CompanyList(props) {
    (0, _classCallCheck3.default)(this, CompanyList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CompanyList.__proto__ || (0, _getPrototypeOf2.default)(CompanyList)).call(this, props));

    _this.renderHoldings = function (currency, holdings, type) {
      if (!holdings || holdings.length === 0) {
        return _react2.default.createElement(
          'div',
          { styleName: 'holdings-none' },
          'NONE'
        );
      }
      var highestLowest = type === 'top' ? 'highest' : 'lowest';
      return (0, _lodash.chain)(holdings).take(MaxPerPage).map(function (holding, idx) {
        return _react2.default.createElement(
          'li',
          { key: idx, styleName: 'holding' },
          idx === 0 ? _react2.default.createElement(
            'div',
            {
              styleName: 'holding-name-' + highestLowest,
              'data-multiline': true,
              'data-effect': 'solid',
              'data-place': 'top',
              'data-for': type + '-tip',
              'data-html': true
              // data-scroll-hide={false}
              , 'data-tip': _format2.default.tooltipHtml('\n                        ' + holding.security_name + ' is\n                        the ' + highestLowest + ' scored holding in this fund\n                      ')
            },
            idx + 1,
            '. ',
            holding.security_name,
            _react2.default.createElement(_reactTooltip2.default, { id: type + '-tip' })
          ) : _react2.default.createElement(
            'div',
            { styleName: 'holding-name' },
            idx + 1,
            '. ',
            holding.security_name
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-asset' },
            _format2.default.perc(holding.long_weight),
            ' of assets'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-invested' },
            _format2.default.money(holding.market_value, true, currency, true),
            ' invested'
          )
        );
      }).value();
    };

    _this.renderCompanies = function (currency, type, label) {
      var description = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var count = arguments[4];
      var holdings = arguments[5];

      count = _convert2.default.int(count);
      if (count === 0) {
        return _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 12, styleName: 'detail-holdings-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'detail-wrapper-empty' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-title-empty' },
              label
            )
          )
        );
      }
      return _react2.default.createElement(
        _reactFlexboxGrid.Col,
        { xs: 12, styleName: 'detail-holdings-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'detail-' + type },
          _react2.default.createElement(
            'div',
            { styleName: 'detail-title-holdings' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-title-base' },
              label
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'detail-description-holdings' },
            description
          ),
          _react2.default.createElement(
            'ul',
            { styleName: 'detail-holdings' },
            _this.renderHoldings(currency, holdings, type)
          )
        )
      );
    };

    return _this;
  }

  (0, _createClass3.default)(CompanyList, [{
    key: 'render',
    value: function render() {
      var currency = this.props.currency;
      var holdings = this.props.holdings;
      var fholdings = this.props.fholdings;
      var fHoldingsMap = mapFundHoldings(fholdings);
      var eqHoldings = holdings.reduce(function (filtered, h) {
        h.market_value = _convert2.default.int(fHoldingsMap[h.id].market_value);
        h.long_weight = fHoldingsMap[h.id].long_weight;
        h.gef_score = h.gef_score === null ? null : _convert2.default.float(h.gef_score);
        if (!(h.gef_score === undefined || h.gef_score === null)) {
          filtered.push(h);
        }
        return filtered;
      }, []);

      var topHoldings = (0, _lodash.orderBy)(eqHoldings, ['gef_score', 'market_value'], ['desc', 'desc']);
      var bottomHoldings = (0, _lodash.orderBy)(eqHoldings, ['gef_score', 'market_value'], ['asc', 'desc']);
      var top = topHoldings.slice(0, 10);
      var bottom = bottomHoldings.slice(0, 10);
      var count = top.length;

      var topDescription = 'The top ' + count + ' holdings in this portfolio with the best scores on the Equileap Gender Scorecard. In the case of ties, the holding with more assets invested is listed higher.';
      var bottomDescription = 'The bottom ' + count + ' holdings in this portfolio with the worst scores on the Equileap Gender Scorecard. In the case of ties, the holding with more assets invested is listed higher.';

      var upArrow = require('../../../static/images/holdings-up-arrow.svg');
      var downArrow = require('../../../static/images/holdings-down-arrow.svg');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          { styleName: 'details' },
          _react2.default.createElement('img', {
            src: upArrow,
            alt: 'Top scoring holdings',
            styleName: 'arrow'
          }),
          this.renderCompanies(currency, 'top', 'Top scoring holdings', topDescription, count, top)
        ),
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          { styleName: 'details' },
          _react2.default.createElement('img', {
            src: downArrow,
            alt: 'Bottom scoring holdings',
            styleName: 'arrow'
          }),
          this.renderCompanies(currency, 'bottom', 'Bottom scoring holdings', bottomDescription, count, bottom)
        )
      );
    }
  }]);
  return CompanyList;
}(_react.Component), _class2.propTypes = {}, _temp)) || _class);
exports.default = CompanyList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyList/CompanyList.js
// module id = 1290
// module chunks = 0